import { BookingWidget } from "@/modules/coaching/booking/components/BookingWidget";
import {
  BookingContextProvider,
  BookingKinds,
} from "@/modules/coaching/booking/context/BookingContext";
import { Route } from "@/routes/embed/coach-matching";

export const CoachMatchingWidget = () => {
  const { customerId, email, name, preSessionNotesEnabled } = Route.useSearch();

  // serviceName is derived in BookingContext from the COACH_MATCHING_SERVICE kind.
  return (
    <BookingContextProvider
      initialData={{
        bookingKind: BookingKinds.COACH_MATCHING_SERVICE,
        preSessionNotesEnabled,
        customerId,
        memberEmail: email,
        memberName: name,
      }}
    >
      <BookingWidget />
    </BookingContextProvider>
  );
};
